import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import {
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextValidatorText,
    TextValidatorTextRequiredDestaque,
    TextValidatorNumberRequired,
    TextValidatorCpf,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
    atribuiDataIdade,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    SexoRadioGroupRequired,
} from '../../../business-rules/RadioGroup/SexoRadioGroup'

import {
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    AvatarClienteConjugeFamiliar
} from './CadastroCompClienteConjugeFamiliares'

import CadastroFormContato from './CadastroFormContato'

import CadastroFormContaInvestimentos from './CadastroFormContaInvestimentos'



export const CardGridDivHeaderEntradaDadosConjuge = ({ values }) => {

    return (
        <CardGridDivHeaderEntradaDados>
            <CardGridDivEntradaDados>
                {tituloConjuge(values)}
            </CardGridDivEntradaDados>
        </CardGridDivHeaderEntradaDados>
    )
}

export const NomeConjuge = ({ values, handleChange }) => {

    return (
        <TextValidatorTextRequiredDestaque
            name="nomeConjuge"
            label={LABEL.nomeConjuge}
            value={values.nomeConjuge || ''}
            onChange={handleChange}
            tamMax={TAMMAX.nome}
        />
    )
}

export const NascimentoConjuge = ({ values, setFieldValue }) => {

    return (
        <MuiPickersUtilsProviderPadrao>
            <KeyboardDatePickerPadrao
                name="nascimentoConjuge"
                label={LABEL.nascimento}
                value={values.nascimentoConjuge}
                onChange={(date) => {
                    atribuiDataIdade(
                        setFieldValue,
                        date,
                        'nascimentoConjuge',
                        'idadeConjuge'
                    )}
                }
            />
        </MuiPickersUtilsProviderPadrao>
    )
}

export const IdadeConjuge = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="idadeConjuge"
            label={LABEL.idade}
            value={values.idadeConjuge === 0 ? 0 : values.idadeConjuge || ''}
            onChange={handleChange}
            numMin={NUMMIN.idadeNascimento}
            numMax={NUMMAX.idade}
            disabled={values.nascimentoConjuge ? true : false}
        />
    )
}

export const SexoConjuge = ({ values, handleChange }) => {

    return (
        <SexoRadioGroupRequired
            name="sexoConjuge"
            value={values.sexoConjuge || ''}
            onChange={handleChange}
        />
    )
}

export const NomeCurtoConjuge = ({ values, handleChange }) => {

    return (
        <TextValidatorText
            name="nomeCurtoConjuge"
            label={LABEL.nomeCurto}
            value={values.nomeCurtoConjuge || ''}
            onChange={handleChange}
            tamMax={TAMMAX.nomeCurto}
        />
    )
}

export const CpfConjuge = ({ values, handleChange }) => {

    return (
        <TextValidatorCpf
            name="cpfConjuge"
            label={LABEL.cpf}
            value={values.cpfConjuge || ''}
            onChange={handleChange}
        />
    )
}

export const ContatoConjuge = ({ values, handleChange }) => {

    return (
        <CadastroFormContato
            familiar={HARDCODE.idFamiliarConjuge}
            values={values}
            handleChange={handleChange}
        />
    )
}

export const ContaInvestimentosConjuge = ({ values, handleChange }) => {

    return (
        <CadastroFormContaInvestimentos
            familiar={HARDCODE.idFamiliarConjuge}
            values={values}
            handleChange={handleChange}
        />
    )
}

export const AvatarConjuge = ({ values, setFieldValue }) => {

    return (
        <AvatarClienteConjugeFamiliar
            name='avatarConjuge'
            value={values.avatarConjuge}
            setFieldValue={setFieldValue}
            sexo={values.sexoConjuge}
        /> 
    )
}